import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Image, P } from "../../../../AbstractElements";
import { Href, PainterTourParagraph } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

export const ThirdStyleAboutSection = () => {
  return (
    <>
      <P className="block-ellipsis">{PainterTourParagraph}</P>
      <Row className="g-3 mt-4 pictures" id="aniimated-thumbnials-2">
        <Col sm="6">
          <Link to={Href}>
            <div className="tour-blog">
              <Image className="img-fluid rounded" src={dynamicImage(`other-images/mountain.jpg`)} alt="mountain" />
            </div>
          </Link>
        </Col>
        <Col sm="6">
          <Link to={Href}>
            <div className="tour-blog">
              <Image className="img-fluid rounded" src={dynamicImage(`other-images/sea.jpg`)} alt="sea" />
            </div>
          </Link>
        </Col>
      </Row>
    </>
  );
};
